import { useHealthQuoteEntryAbTest } from '~/composables/use-health-quote-entry-ab-test'
import { QUOTE_ENTRY_STEP0_ROUTE, QUOTE_ENTRY_STORAGE_KEY } from '~/constants/pages/health-quote-entry'

/**
 * Fast path for the variant-only who-needs-health-cover page: once the
 * healthQuickQuoteVariant assignment has been resolved this session, control and
 * unassigned users are bounced to step0 before the page mounts. The page itself
 * still resolves and redirects when the assignment is not yet known.
 */
export default defineNuxtRouteMiddleware(to => {
  if (import.meta.server) return

  const { resolved, isVariant } = useHealthQuoteEntryAbTest()
  if (!resolved.value || isVariant.value) return

  removeSession(QUOTE_ENTRY_STORAGE_KEY)
  return navigateTo({ path: QUOTE_ENTRY_STEP0_ROUTE, query: to.query }, { replace: true })
})
